import React from "react";
import { Form, Select } from "antd";
import ControlledInputBox from "../../components/ControlledInputBox";
import ControlledSelectBox from "../../components/Backoffice/ControlledSelect";
import { getSortedList } from "../../utils/sortHelper";
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const UserAddressForm = ({
  control,
  options = {},
  watch,
  errors,
  setValue,
}) => {
  const { states = [], cities = [], countries = [] } = options;
  const selectedCountry = watch("country");
  const selectedState = watch("state");

  const getCountryOptions = () => {
    const opts = [];
    countries.forEach((country) => {
      opts.push(
        <Option key={country._id} value={country._id}>
          {country.name}
        </Option>
      );
    });
    return opts;
  };

  const getStateOptions = (countryId) => {
    const opts = [];
    const filteredStates = states.filter(
      (state) => state.country === countryId
    );
    const sortedStates = getSortedList(filteredStates);
    sortedStates.forEach((state) => {
      opts.push(
        <Option key={state._id} value={state._id}>
          {state.name}
        </Option>
      );
    });
    return opts;
  };

  const getCityOptions = (stateId) => {
    const opts = [];
    const filteredCities = cities.filter((city) => city.state === stateId);
    const sortedCities = getSortedList(filteredCities);
    sortedCities.forEach((city) => {
      opts.push(
        <Option key={city._id} value={city._id}>
          {city.name}
        </Option>
      );
    });
    return opts;
  };

  return (
    <Form {...formItemLayout}>
      <ControlledInputBox
        required
        control={control}
        errors={errors}
        name="addressLine1"
        label="Address Line 1"
      />
      <ControlledInputBox
        control={control}
        errors={errors}
        name="addressLine2"
        label="Address Line 2"
      />
      <ControlledSelectBox
        control={control}
        required
        errors={errors}
        name="country"
        options={getCountryOptions()}
        customChange={() => {
          setValue("state", "");
          setValue("city", "");
        }}
        label="Country"
      />
      <ControlledSelectBox
        control={control}
        required
        errors={errors}
        name="state"
        customChange={() => {
          setValue("city", "");
        }}
        options={getStateOptions(selectedCountry)}
        label="State"
      />
      <ControlledSelectBox
        control={control}
        required
        errors={errors}
        name="city"
        options={getCityOptions(selectedState)}
        label="City"
      />
      <ControlledInputBox
        required
        control={control}
        errors={errors}
        name="pincode"
        label="Pincode"
      />
    </Form>
  );
};

export default UserAddressForm;
